import { render } from "./Cursors.vue?vue&type=template&id=b02e483c&ts=true"
import script from "./Cursors.vue?vue&type=script&lang=ts"
export * from "./Cursors.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__